import { type GroupedStudent } from "@live-writing/models";

export default function StudentPill({ student, onClick }: { student: GroupedStudent; onClick?: () => void }) {
  return (
    <button
      onClick={onClick}
      type="button"
      className="inline-flex items-center gap-2 bg-transparent rounded px-1 py-0.5 hover:bg-gray-100 transition-colors focus:outline-none"
      aria-label={`Open transcript for ${student.first_name} ${student.last_name_initial}`}
    >
      <div
        className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium shrink-0"
        style={{ backgroundColor: student.avatar_color }}
      >
        {student.first_name.charAt(0)}
      </div>
      <div className="text-sm text-foreground">
        {student.first_name} {student.last_name_initial}.
      </div>
    </button>
  );
}
